import { render, staticRenderFns } from "./MessageViewers.vue?vue&type=template&id=928304f2&"
import script from "./MessageViewers.vue?vue&type=script&lang=js&"
export * from "./MessageViewers.vue?vue&type=script&lang=js&"
import style0 from "./MessageViewers.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MessageViewers.vue"
export default component.exports